











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EndCheckInMutation_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removedSuggestedActionId",
      "storageKey": null
    }
  ],
  "type": "EndCheckInSuccess",
  "abstractKey": null
};

(node ).hash = "6efcb96c655e163c9af8f0ab726ddf15";

export default node;
